var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.165,
    height: 26.157,
    viewBox: "0 0 26.165 26.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-close-4953021",
    d: "M37.392,35.774a1.13,1.13,0,0,1-1.6,1.6L25.417,27a.376.376,0,0,0-.532,0L14.507,37.372a1.13,1.13,0,0,1-1.6-1.6L23.285,25.4a.377.377,0,0,0,0-.532L12.909,14.487a1.13,1.13,0,0,1,1.6-1.6L24.884,23.265a.376.376,0,0,0,.532,0L35.794,12.889a1.13,1.13,0,0,1,1.6,1.6L27.016,24.864a.377.377,0,0,0,0,.532Z",
    transform: "translate(-12.068 -12.048)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelX);
export default __webpack_public_path__ + "static/media/cancel-x.73032735c86f5428abd229257100e080.svg";
export { ForwardRef as ReactComponent };